import React, { FC, useEffect, useRef } from 'react'

import { SubscribeModalClose } from '../../../constants/svg'
import { ComponentSubscribe } from '../../../models/components/subscribe'
import { SubscribeContainer } from './style'
import { SubscribeModalContent } from './subcomponent'

type Props = {
  data: ComponentSubscribe | null
}

const SubscribeModal: FC<Props> = ({ data }) => {
  if (!data) return null
  const subscribeData = {
    modal: {
      headline: data.landingModalHeadline || '',
      subheadline: data.landingModalSubheadline || '',
    },
    success: {
      headline: data.successHeadline || '',
      message: data.successMessage?.successMessage || data?.successMessage || '',
    },
  }

  const modalRef = useRef<HTMLDivElement>(null)

  const handleOpen = () => {
    if (modalRef && modalRef.current) {
      modalRef.current.classList.add('SubscribeModal--Visible')
    }
  }

  const handleClose = () => {
    if (modalRef && modalRef.current) {
      modalRef?.current?.classList.remove('SubscribeModal--Visible')
      sessionStorage.setItem('subscribeModalClosed', 'true')
    }
  }

  const getScrollPercent = () => {
    const scrolledAmount =
      window.scrollY ||
      document.scrollingElement?.scrollTop ||
      document.documentElement?.scrollTop ||
      document.body?.scrollTop ||
      0

    const scrollableAmount =
      (document.documentElement?.scrollHeight || document.body?.scrollHeight) -
      document.documentElement?.clientHeight

    return (scrolledAmount / scrollableAmount) * 100
  }

  useEffect(() => {
    if (typeof window !== 'undefined' && sessionStorage?.getItem('formSubmitted')) {
      modalRef?.current?.classList.add('formSubmitted')
    }
  }, [])

  useEffect(() => {
    const allModalTriggers = document.querySelectorAll('.SubscribeModal__Trigger')

    for (let i = 0; i < allModalTriggers.length; i++) {
      allModalTriggers[i].addEventListener('click', e => {
        e.preventDefault()
        handleOpen()
      })
    }

    document.addEventListener('scroll', e => {
      if (getScrollPercent() >= 40) {
        if (
          !sessionStorage?.getItem('formSubmitted') &&
          !sessionStorage?.getItem('subscribeModalClosed')
        ) {
          handleOpen()
        }
      }
    })
  }, [])

  return (
    <SubscribeContainer ref={modalRef} data-cy="SubscribeModal">
      <SubscribeModalContent
        subscribeData={subscribeData}
        modalRef={modalRef}
        marketoForm={data.marketoForm}
      />
      <SubscribeModalClose handleClose={handleClose} />
    </SubscribeContainer>
  )
}

export default SubscribeModal
